<template>
  <v-snackbar :value="true" :timeout="0">
    <span v-if="refreshingApp">
      {{ $vuetify.lang.t('$vuetify.LOADING_NEW_CONTENT') }}
    </span>
    <span v-else>
      {{ $vuetify.lang.t('$vuetify.NEW_CONTENT_AVAILABLE') }}
    </span>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="primary" class="primary--text"
        text
        small
        v-bind="attrs"
        @click="$emit('refresh')"
      >
        {{ $vuetify.lang.t('$vuetify.REFRESH') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'NewContentAvailableSnackbar',
  props: {
    refreshingApp: { type: Boolean, default: false, required: true }
  }
}
</script>
